var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 45,
    viewBox: "0 0 42 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.73401 16.189C6.64352 24.7909 8.79385 33.4124 10.057 42.1443C10.7626 47.0222 9.21323 39.9833 9.02063 38.9882C8.60369 36.834 8.12562 34.9258 8.12562 32.7231C8.12562 28.2898 8.00688 23.807 7.67812 19.3686C7.44798 16.2618 3.63171 7.01088 8.45536 14.7287C13.3738 22.5983 16.8463 31.2988 20.1847 39.8832C20.6447 41.0661 21.282 42.1872 21.7863 43.3219C22.0618 43.9417 16.8991 38.8961 14.9088 37.8105",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76624 35.2668C7.27789 33.0673 19.4311 28.919 22.9638 22.7367C24.4438 20.1467 24.1556 21.3444 19.9962 22.1243",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3005 6.43809C22.5541 14.8584 25.6348 23.8242 26.8031 33.1706C26.9114 34.0366 27.1125 34.9873 27.7217 35.5965C27.8348 35.7097 25.6816 31.6794 25.0838 30.6033",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3005 6.01416C21.5988 7.99001 33.7134 15.2872 25.8139 19.9339C25.1206 20.3417 24.3077 20.7182 23.8119 21.3706C22.7622 22.7519 22.6356 23.1573 23.388 21.2764",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3231 1.7746C30.728 11.2932 33.1387 21.7521 33.1387 31.4512C33.1387 33.5923 32.7808 29.6269 32.2908 28.4835",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.074 18.7327C41.4015 25.6713 42.5984 29.7597 35.7766 31.781C33.4455 32.4716 36.2622 29.0859 36.86 28.672C38.9008 27.2591 40.9327 22.7112 38.65 20.4285C37.7419 19.5203 35.568 20.6674 34.9287 19.5806C33.9863 17.9786 36.0984 14.9455 37.3782 14.1634C41.0591 11.914 40.596 15.0839 39.074 14.0692",
    stroke: "#2F7578",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApi);
export default __webpack_public_path__ + "static/media/api.2fa279278c41153fdc03ef8e87b383f2.svg";
export { ForwardRef as ReactComponent };